import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requiredWithoutWhitespaces(control: AbstractControl): ValidationErrors | null {
  const isValid = control.value && control.value.trim().length > 0;
  return isValid ? null : { required: true };
}
